import axios from 'axios';
import { message } from 'ant-design-vue';
import store from '../store/store';
import router from '../router';

const hostApi = process.env.NODE_ENV === 'production' ? '/' : '/api/';
axios.defaults.baseURL = hostApi;
axios.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded';
// 跳转到登陆页面
const toLogin = () => {
  router.push('/login');
};
const errCodeList = {
  20000001: 'session已过期',
};

// 请求失败后的错误统一处理
const errorHandle = (status, other) => {
  // 状态码判断
  switch (status) {
    // 401: 未登录状态，跳转登录页
    case 401:
      toLogin();
      break;
    // 403 token过期
    // 清除token并跳转登录页
    // case 403:

    //   // tip('登录过期，请重新登录');
    //   // localStorage.removeItem('token');
    //   // store.commit('loginSuccess', null);
    //   // setTimeout(() => {
    //   //   toLogin();
    //   // }, 1000);
    //   break;
    // 404请求不存在
    case 404:
      // tip('请求的资源不存在');
      break;
    default:
      // eslint-disable-next-line no-console
      console.log(`接口报错${other}`);
  }
};

// 请求成功但是code不为0的错误统一处理
const errorCode = (code) => {
  if (errCodeList[code]) {
    if (code === 20000001) {
      toLogin();
      localStorage.clear();
      sessionStorage.clear();
    }
  } else {
  }
};
// 请求拦截器
axios.interceptors.request.use(
  (config) => {
    let userInfo = store.state.userInfo.jwtToken
    if (userInfo) {
      config.headers.Authorization = userInfo
    }
    return config;
  },
  error => Promise.error(error),
);
// 响应拦截器
axios.interceptors.response.use(
  (response) => {
    if ((response.status === 200 && response.data.code === 0) || (response.status === 200 && response.data.size > 0)) {
      // eslint-disable-next-line radix
      return response;
    }
    errorCode(response.data.code, response);
    return response;
  },
  // 请求失败
  (error) => {
    const { response } = error;
    if (response) {
      // 请求已发出，但是不在2xx的范围
      errorHandle(response.status, response.data.message);
      return Promise.reject(response);
    }
    return error;
  },
);
export default axios;



// WEBPACK FOOTER //
// ./src/axios/http.js